import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M9.649 16.297 14.999 9l-7.296 5.351-4.3-2.15c-1.605-.802-1.422-3.15.289-3.694l13.623-4.335c1.547-.492 3.005.966 2.512 2.513l-4.334 13.623c-.545 1.71-2.892 1.894-3.695.288z"
    }
  )
);
var SvgSendFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SendFilled_default = SvgSendFilled;

export { SendFilled_default as default };
